import { START_LOADER, STOP_LOADER } from './types'

export const startLoader = payload => ({ type: START_LOADER, payload })
export const stopLoader = payload => ({ type: STOP_LOADER, payload })
